import { render, staticRenderFns } from "./PageClubInvoiceEvents.vue?vue&type=template&id=68aece26&scoped=true&"
import script from "./PageClubInvoiceEvents.vue?vue&type=script&lang=js&"
export * from "./PageClubInvoiceEvents.vue?vue&type=script&lang=js&"
import style0 from "./PageClubInvoiceEvents.vue?vue&type=style&index=0&id=68aece26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68aece26",
  null
  
)

export default component.exports